import { render, staticRenderFns } from "./infoSet.vue?vue&type=template&id=24d5766d&scoped=true"
import script from "./infoSet.vue?vue&type=script&lang=js"
export * from "./infoSet.vue?vue&type=script&lang=js"
import style0 from "./infoSet.vue?vue&type=style&index=0&id=24d5766d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5766d",
  null
  
)

export default component.exports